<template>
  <v-row 
    id="notificationRequestAccess"
    column
    scrollable
  >
    <v-dialog v-model="showRejectionDialog" max-width="400">
      <v-card>
        <v-card-text class="pt-4">Informe al contratista que su ingreso fue rechazado</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showRejectionDialog = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="confirmRejection()">Rechazo informado</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-list v-if="!isAdmin" three-line dense>
      <v-subheader primary>{{ title }}</v-subheader>
      <v-list-item v-for="item in filteredItems"
        :key="item._id"
        @click="handleSecurityNotification(item)"
        ripple>
        <v-list-item-content>
          <v-list-item-title class="colorable"
            v-if="item.type == 'approval_request'
            && item.data.requestAccess.contractorVisit.state == 'authorized'">{{
            item.data.requestAccess.contractorCompany.contractor.name
          }}
          </v-list-item-title>
          <v-list-item-title v-else>{{
            item.data.requestAccess.contractorCompany.contractor.name
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            item.data.requestAccess.contractorCompany.type.name
          }}</v-list-item-subtitle>
          <v-list-item-subtitle v-if="item.type == 'approval_request'"
            >Fue aprobado</v-list-item-subtitle
          >
          <v-list-item-subtitle v-else>Fue rechazado</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list v-else three-line dense>
      <v-subheader>{{ title }}</v-subheader>
      <v-list-item
        v-for="item in filteredItems"
        :key="item._id"
        @click="handleCompanyAdminNotification(item)"
        ripple
      >
        <v-list-item-content v-if="item.type == 'visit_cancelled'">
          <v-list-item-title>{{
            item.data.requestAccess.contractorCompany.contractor.name
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            resx.labels.accessCancelled
          }}</v-list-item-subtitle>
          <v-list-item-subtitle>{{
            timeFromNow(item.date)
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-list-item-title>{{
            item.data.requestAccess.contractorCompany.contractor.name
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            item.data.requestAccess.contractorCompany.type.name
          }}</v-list-item-subtitle>
          <v-list-item-subtitle>{{
            timeFromNow(item.data.requestAccess.requestDate)
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <!-- <v-btn id="viewAll" :to="{name: 'history'}" block small color="primary">{{resx.labels.viewAll}}</v-btn> -->
  </v-row>
</template>

<script>
import moment from "moment";
import notificationService from "@/services/NotificationService";
import constants from "@/utils/constants";
export default {
  name: "notificationRequestAccess",
  data() {
    return {
      filteredItems: [],
      selectedRequestAccess: null,
      showRejectionDialog: false,
      pendingRejectionNotification: null
    };
  },
  mounted() {
    this.processItems(this.items);
  },
  methods: {
    goToContractor(item) {
      if (item.type == 'approval_request'
        && item.data.requestAccess.contractorVisit.state == 'authorized') {
        this.$router.push(`/contractors/${item.data.requestAccess.contractorCompany.id}/profile`)
      } else {
        return;
      }
    },
    timeFromNow(dateTime) {
      return moment(dateTime).fromNow();
    },
    handleCompanyAdminNotification(notification) {
      if (notification.type == 'visit_cancelled') {
        this.markAsRead(notification._id);
      } else {
        this.$emit("selectRequestAccess", notification);
      }
    },
    async handleSecurityNotification(notification) {
      if (notification.type == 'rejected_request') {
        this.pendingRejectionNotification = notification;
        this.showRejectionDialog = true;
        return;
      }
      if (notification.type == 'visit_cancelled') {
        await notificationService.remove(notification._id)
        this.markAsRead(notification._id);
      }
      this.markAsRead(notification._id);
      this.goToContractor(notification);
    },
    async confirmRejection() {
      this.showRejectionDialog = false;
      await this.markAsRead(this.pendingRejectionNotification._id);
      this.pendingRejectionNotification = null;
    },
    async markAsRead(id) {
      await notificationService.markAsRead([id]);
      await this.filteredItems.map(filteredItem => {
        if (filteredItem.id == id) {
          filteredItem.wasReadBy.push(this.$store.state.auth.user.id);
        }
        return filteredItem;
      });
      this.processItems(this.filteredItems);
    },
    processItems(items) {
      if (items) {
        this.filteredItems = items.filter(item => {
          if ((item.wasReadBy.length > 0 && item.wasReadBy.includes(this.$store.state.auth.user.id))
          &&  ((this.$store.state.auth.user["roles"][0] == constants.ROLES.SECURITY && item.type == 'rejected_request')
          || (this.$store.state.auth.user["roles"][0] == constants.ROLES.ADMIN && item.type == 'visit_cancelled')
          || (this.$store.state.auth.user["roles"][0] == constants.ROLES.USER && item.type == 'visit_cancelled'))
          ) {
            return false;
          }
          return true;
        }).slice(0, 5);
        this.$emit("updateRequestAccessesCount", this.filteredItems.length);
      }
    }
  },
  props: {
    requestAccessesCount: { type: Number },
    items: { type: Array },
    title: { type: String },
    isAdmin: { type: Boolean }
  },
  watch: {
    items(items) {
      this.processItems(items);
    }
  }
};
</script>

<style lang="scss">
#notificationRequestAccess {
  display: contents;

  .v-list--dense .v-subheader {
    font-size: 1rem;
  }

  .colorable {
    color: #2196f3 !important;
    .v-icon {
    font-size: 15px;
    }
  }
}
</style>
